import {PlayingState} from '../engine/playable/playable';
import {Quality} from '../engine/playable/qualities';

export enum ActionTypes {
  INIT = '[Player] Set start parameters',
  SET_VIDEO_TYPE = '[Player] Set video type',
  SET_QUALITIES = '[Player] Set qualities',
  SELECT_QUALITY = '[Player] Select playing quality',
  SET_QUALITY = '[Player] Set playing quality',

  TOGGLE_PLAY = '[Player] Toggle play',
  SET_PLAYING_STATE = '[Player] Set playing state',
  SET_LOADING = '[Player] Set loading state',
  SET_STATS = '[Player] Set playable stats',
  LOG = '[Player] Log',

  TOGGLE_MUTE = '[Player] Toggle mute',
  SET_VOLUME = '[Player] Set volume',

  SET_CURRENT_TIME = '[Player] Set current time',
  SET_TOTAL_TIME = '[Player] Set total time',
  SEEK_TO = '[Player] Set seek position',
  SEEK_TO_LIVE = '[Player] Seek to live',

  REQUEST_API = '[Player] Request api',
  SET_API_DATA = '[Player] Set api data',
  SET_VIEWERS = '[Player] Set viewers',

  TOGGLE_UI = '[Player] Toggle UI',
}

export class Init {
  static readonly type = ActionTypes.INIT;

  constructor(public payload: {}) {
  }
}

export class TogglePlay {
  static readonly type = ActionTypes.TOGGLE_PLAY;
}

export class ToggleMute {
  static readonly type = ActionTypes.TOGGLE_MUTE;
}

export class SetVolume {
  static readonly type = ActionTypes.SET_VOLUME;

  constructor(public payload: { volume: number }) {
  }
}

export class SetPlayingState {
  static readonly type = ActionTypes.SET_PLAYING_STATE;

  constructor(public payload: { state: PlayingState }) {
  }
}

export class SetLoading {
  static readonly type = ActionTypes.SET_LOADING;

  constructor(public payload: { loading: number }) {
  }
}

export class SetPlayableStats {
  static readonly type = ActionTypes.SET_STATS;

  constructor(public payload: any) {
  }
}

export class AppendPlayableLog {
  static readonly type = ActionTypes.LOG;

  constructor(public payload: string) {
  }
}

export class SetCurrentTime {
  static readonly type = ActionTypes.SET_CURRENT_TIME;

  constructor(public payload: { value: number }) {
  }
}

export class SetTotalTime {
  static readonly type = ActionTypes.SET_TOTAL_TIME;

  constructor(public payload: { value: number }) {
  }
}

export class SeekTo {
  static readonly type = ActionTypes.SEEK_TO;

  constructor(public payload: { position: number }) {
  }
}

export class SeekToLive {
  static readonly type = ActionTypes.SEEK_TO_LIVE;

  constructor(public payload = null) {
  }
}


export class SetVideoType {
  static readonly type = ActionTypes.SET_VIDEO_TYPE;

  constructor(public payload: { seekable: boolean, live: boolean }) {
  }
}

export class SetQualities {
  static readonly type = ActionTypes.SET_QUALITIES;

  constructor(public payload: { qualities: Quality[] }) {
  }
}

export class SelectQuality {
  static readonly type = ActionTypes.SELECT_QUALITY;

  constructor(public payload: { quality: Quality }) {
  }
}

export class SetQuality {
  static readonly type = ActionTypes.SET_QUALITY;

  constructor(public payload: { quality: Quality }) {
  }
}

export class RequestApi {
  static readonly type = ActionTypes.REQUEST_API;

  constructor(public payload: { streamkey: string }) {
  }
}

export class ToggleUI {
  static readonly type = ActionTypes.TOGGLE_UI;

  constructor(public payload: { state: boolean }) {
  }
}

export class SetApiData {
  static readonly type = ActionTypes.SET_API_DATA;

  constructor(public payload: any) {
  }
}
